import { styled } from "styled-components";

export const HomeMenuWrapper = styled.div`
  background: #233e99;
`;
export const HomeMainWrap = styled.ul`
  padding: 56px 0;
  display: flex;
  gap: 40px;

  li {
    width: calc(25% - 120px / 4);
    a {
      padding: 24px;
      display: flex;
      align-items: center;
      border: 1px solid #8798d2;
      justify-content: space-between;
      text-align: left;
      > div {
        display: flex;
        flex-direction: column;
        gap: 4px;
        h6 {
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
          color: #fbfbfb;
        }
        p {
          color: #8798d2;
          font-size: 16px;
          line-height: 1.5;
          .xl-br {
            display: none;
          }
        }
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  @media all and (max-width: 1180px) {
    gap: 20px;
    li {
      width: calc(25% - 60px / 4);
      a {
        min-height: 125px;
        padding: 14px 20px;
        > div {
          h6 {
            font-size: 22px;
            line-height: 28px;
          }
          p {
            .xl-br {
              display: block;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    flex-wrap: wrap;
    padding: 40px 0;
    li {
      width: calc(50% - 20px / 2);
    }
  }
  @media all and (max-width: 768px) {
    padding: 5.208vw 0;
    gap: 1.302vw;
    li {
      width: calc(50% - 0.651vw);
      a {
        min-height: 19.01vw;
        padding: 2.083vw 1.563vw 2.083vw 3.125vw;
        > div {
          h6 {
            font-size: 3.646vw;
            line-height: 4.688vw;
          }
          p {
            font-size: 3.125vw;
          }
        }
        img {
          width: 4.167vw;
          height: 4.167vw;
        }
      }
    }
  }
`;

export const HomeContentsContainer = styled.div`
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  gap: 64px;
  @media all and (max-width: 768px) {
    padding: 10.417vw 0 18.229vw;
    gap: 6.51vw;
  }
`;

export const HomeContentsWrapper = styled.div``;

export const HomeContentsWrap = styled.div``;

export const HomeNoticeWrapper = styled.div``;
export const HomeNoticeWrap = styled.div``;
